import { gql } from "@apollo/client";

export const UPDATE_OUTFIT_MUTATION = gql`
  mutation updateOutfit($input: UpdateOutfitInput!) {
    updateOutfit(input: $input) {
      success
      outfit {
        id
        occasion
        imageUrl
        outfitItems {
          id
          category {
            id
            name
          }
          colors
          style
          imageUrl
        }
        reasonings {
          id
          role
          message
          createdAt
        }
      }
      errors {
        fullMessages
      }
    }
  }
`;

export const GENERATE_OUTFIT_MUTATION = gql`
  mutation generateOutfit($input: GenerateOutfitInputType!) {
    generateOutfit(input: $input) {
      success
      imageGenerationStatus
      outfit {
        id
        occasion
        outfitItems {
          id
          category {
            id
            name
          }
          colors
          style
          imageUrl
        }
        reasonings {
          id
          role
          message
          createdAt
        }
      }
      errors {
        fullMessages
      }
    }
  }
`;

export const FAVORITE_OUTFIT_MUTATION = gql`
  mutation favoriteOutfit($id: ID!) {
    favoriteOutfit(id: $id) {
      success
      message
    }
  }
`;

export const DELETE_OUTFIT_MUTATION = gql`
  mutation DeleteOutfit($id: ID!) {
    deleteOutfit(id: $id) {
      success
      errors {
        fullMessages
      }
    }
  }
`;
